import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import { EventsInfoComponent } from '../../user-info/user-info.component';
import {TranslateService} from '@ngx-translate/core';
import {TranslateModule } from '@inspark/inspark-components';
import {
  EventActivity,
  EventLogActivity,
  EventLogParam
} from '../../../../../projects/api/src/event-log/event-log.model';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {Dashboard} from '../../../../../projects/api/src/dashboard/dashboard.model';
import {TIncomingMessage} from '../../header/header-notifications/header-notifications.service';

import {environment} from '../../../../environments/environment';
import { Router} from '@angular/router';
import {InsparkUIModule} from '../../../inspark.module';

const eventLogUrl = environment.backEndUrlPrefix.substring(0,environment.backEndUrlPrefix.indexOf('sem-restservices')) + 'app/#!/main/eventslog/list';

function isNotificationType(obj: EventLogActivity | TIncomingMessage): obj is TIncomingMessage {
  return obj.hasOwnProperty('serialnumber');
}

@Component({
  selector: 'app-event',
  standalone: true,
  imports: [CommonModule, CheckboxModule, EventsInfoComponent, InsparkUIModule, TranslateModule, FormsModule],
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {
  event: EventLogActivity | null;
  origEvent: EventLogActivity | TIncomingMessage | null;
  protected readonly eventLogUrl = eventLogUrl;
  eventLogIDUrl: string = eventLogUrl;

  @Input() set item(value: EventLogActivity | TIncomingMessage | null) {
    if ( isNotificationType(value) ) {
      this.origEvent = value;
      this.event = {
        id: value.eid,
        timestmp: value.timestamp,
        msg: value.details,
        controller: {
          serialnumber: value.serialnumber,
          object: { shortname: value.shortname }
        },
        event: {
          sdircriticality: {
            criticalname: value.status
          }
        },
        incident: {
          extSystem: { id: '', name: '', url: '' }
        },
        processed: false,
        closed: false,
        closeTime: 0
      };
    } else {
      this.event = value;
    }
  };

  get evItem() {
    return this.event;
  }
  @Input() currentEventId: number | null;
  @Input() set selectedValues(items: EventActivity[]) {
    this._selectedValues = items;
    this.selectedValuesChange.emit(items);
  }
  @Input() hideButtons = false;
  @Input() isNotification = false;

  _selectedEvent: EventLogActivity;

  get selectedEvent() {
    return this._selectedEvent;
  }

  @Input() set selectedEvent(item: EventLogActivity) {
    this._selectedEvent = item;
    this.selectedEventChange.emit(item);
  }

  @Output() onSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedValuesChange = new EventEmitter<EventActivity[]>();  // EventLogActivity[] = [];
  @Output() selectedEventChange = new EventEmitter<EventLogActivity>();
  @Output() acceptMessage? = new EventEmitter<any>();

  @ViewChild('borderDesktop', {static: false}) borderDesktop: NgbTooltip;
  borders: { [k: string]: { loading: boolean; data: any } } = {};
  activities: { [k: string]: { loading: boolean; data: EventActivity[] } } = {};
  dashboards: { [k: string]: Dashboard[] } = {};
  params: { [k: string]: { loading: boolean; borderLoading?: boolean; data: EventLogParam } } = {};
  private subscriptions = [];
  isGeo = false;

  _selectedValues: EventActivity[] = [];

  constructor(
    public translateService: TranslateService,
    private router: Router,
  ) { }

  get selectedValues() {
    return this._selectedValues;
  }

  ngOnInit(): void {
    this.eventLogIDUrl = `${this.eventLogUrl}?id=${this.event.id}`;
  }

  navigateToLog() {
    if ( this.isNotification ) {
      // TODO: заменить на роут к событию
      if ( this.router.url === '/main/eventslog/list' ) {
        window.open(`${this.eventLogUrl}?id=${this.event.id}`, '_self');
      } else {
        window.open(`${this.eventLogUrl}?id=${this.event.id}`, '_blank');
      }
    }
  }

  onAccept(event) {
    event.stopPropagation();
    this.acceptMessage.emit(this.origEvent);
  }

  onShowExternalIncident(item, event, incident): void {
    if (!this.isNotification && item.incident && item.incident.extSystem) {
      incident.open();
      event.stopImmediatePropagation();
    }
  }

  get getNotificationEventStatusClass() {
    if ( this.isNotification ) {
      return 'event_notification event__status_'+ (this.evItem.event?.sdircriticality.criticalname);
    }
  }

  log(value) {
    console.log(value);
    return true;
  }

  hideImg(event, preview) {
    event.hideImage = true;
  }

  showImg(event, preview) {
    event.hideImage = false;
  }

}
